import './PictureLesson.scss';
import { Modal } from '@trackman/web-shared-components';
import { useState } from 'react';

type PictureLessonProps = {
  imageUrl: string;
  imageTitle: string;
};

export const PictureLesson = ({ imageUrl, imageTitle }: PictureLessonProps) => {
  const [open, setOpen] = useState(false);
  const img = new Image();
  img.src = imageUrl;

  return (
    <>
      <div className='picture-wrapper'>
        <img
          className={img.naturalHeight > img.naturalWidth ? 'picture picture-vertical' : 'picture'}
          src={imageUrl}
          alt={imageTitle}
          onClick={() => setOpen(true)}
        ></img>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} className='picture-modal'>
        <div className='modal-body'>
          <img src={imageUrl} alt={imageTitle}></img>
        </div>
      </Modal>
    </>
  );
};
